import * as api from "api";
import { toast } from "react-toastify";

export async function fetchBatchPostingDocuments(dataItem) {
    if (dataItem.chitId) {
        const { data } = await api.getChitDocuments(dataItem.chitId);
        const documents = data.data || [];

        if (!documents.length) {
            toast.error("No documents found");
            return null;
        }

        return documents;
    }

    if (dataItem.documentFiles?.length > 0) {
        const fileIDs = dataItem.documentFiles
            .map((file) =>
                file.fileID ||
                (typeof file === "string" || typeof file === "number" ? file : null),
            )
            .filter((id) => id != null);

        if (fileIDs.length === 0) {
            toast.error("No valid file IDs found");
            return null;
        }

        const documentResponses = await Promise.all(
            fileIDs.map((fileID) => api.getFileById(fileID)),
        );

        const documents = documentResponses.map((response) => response.data.data);

        if (!documents.length) {
            toast.error("No documents found");
            return null;
        }

        return documents;
    }

    toast.error("No documents available");
    return null;
}
